export default function genererCritereRecherche() {
  return {
    client: '',
    codeDossier: '',
    etat: [],
    datesPremierAffichage: {
      dateDebut: null,
      dateFin: null,
    },
    dates: {
      dateDebut: null,
      dateFin: null,
    },
    datesValidite: {
      dateDebut: null,
      dateFin: null,
    },
    agencesId: [],
    tiersId: [],
    categorieVente: [],
    commercialId: null,
    assistantIds: null,
    referenceIds: [],
    ids: [],
    groupeIds: [],
    enseigneIds: [],
    idFacture: null,
    themes: [],
    clients: [],
    estSigne: null,
    interne: false,
    produitsIds: [],
    parutionsIds: [],
    planMediaIds: [],
    reconductible: null,
    renouvelable: null,
    departements: [],
    estIndexable: null,
    indicesIndexations: [],
    secteurIds: [],
    tagIds: [],
    estSigneElectroniquement: null,
  };
}
